var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types.ts
var CONFIG_LEVELS_REGISTRY = [
  {
    level: "hopdrive",
    label: "HopDrive Defaults",
    priority: 0
    // No table - defaults are hardcoded
  },
  {
    level: "region",
    label: "Region",
    priority: 1,
    table: { tableName: "regions", idField: "id", nameField: "name" }
  },
  {
    level: "organization",
    label: "Organization",
    priority: 2,
    table: { tableName: "organizations", idField: "id", nameField: "name" }
  },
  {
    // An OEM program a customer is enrolled in. Sits below the customer so a
    // program can switch a setting on for every enrolled dealer while any one
    // dealer can still override it.
    level: "program",
    label: "Program",
    priority: 3,
    table: { tableName: "programs", idField: "id", nameField: "name" }
  },
  {
    level: "customer",
    label: "Customer",
    priority: 4,
    table: { tableName: "customers", idField: "id", nameField: "name" }
  },
  {
    level: "workflowset",
    label: "Workflow Set",
    priority: 5,
    table: { tableName: "workflowsets", idField: "id", nameField: "name" }
  },
  {
    level: "raterulegroup",
    label: "Contract",
    priority: 6,
    table: { tableName: "contracts", idField: "id", nameField: "name" }
  },
  {
    level: "move",
    label: "Move",
    priority: 7,
    table: { tableName: "moves", idField: "id" }
  }
];
var LEVELS = {
  HOPDRIVE: "hopdrive",
  REGION: "region",
  ORGANIZATION: "organization",
  PROGRAM: "program",
  CUSTOMER: "customer",
  WORKFLOWSET: "workflowset",
  CONTRACT: "raterulegroup",
  /** @deprecated Use `LEVELS.CONTRACT` instead */
  RATERULEGROUP: "raterulegroup",
  MOVE: "move"
};
var ALL_CONFIG_LEVELS = CONFIG_LEVELS_REGISTRY.slice().sort((a, b) => a.priority - b.priority).map((info) => info.level);
var CONFIG_TABLES = CONFIG_LEVELS_REGISTRY.filter(
  (info) => info.table !== void 0
).map((info) => ({
  tableName: info.table.tableName,
  level: info.level,
  idField: info.table.idField,
  nameField: info.table.nameField
}));
function getConfigLevelInfo(level) {
  return CONFIG_LEVELS_REGISTRY.find((info) => info.level === level);
}
function getConfigTableForLevel(level) {
  return CONFIG_TABLES.find((t) => t.level === level);
}
function levelHasTable(level) {
  const info = getConfigLevelInfo(level);
  return info?.table !== void 0;
}
var CATEGORIES = {
  METADATA: {
    key: "metadata",
    label: "Metadata",
    description: "Schema versioning and system metadata"
  },
  APPOINTMENTS: {
    key: "appointments",
    label: "Appointments",
    description: "Appointment scheduling and management settings"
  },
  APPOINTMENT_MANAGEMENT: {
    key: "appointment-management",
    label: "Appointment Management",
    description: "Advanced appointment management and workflow configuration"
  },
  APPRAISALS: {
    key: "appraisals",
    label: "Appraisals",
    description: "Vehicle appraisal configuration and settings"
  },
  BILLING: {
    key: "billing",
    label: "Billing",
    description: "Billing, invoicing, and payment configuration"
  },
  BRANDING: {
    key: "branding",
    label: "Branding",
    description: "White-label branding and visual customization settings"
  },
  CARS_ARRIVE: {
    key: "cars-arrive",
    label: "CarsArrive",
    description: "CarsArrive integration behavior, customer onboarding, invoicing, and photo sync"
  },
  CUSTOM_SETTINGS: {
    key: "custom-settings",
    label: "Custom Settings",
    description: "Custom configuration values and settings"
  },
  DASHBOARD: {
    key: "dashboard",
    label: "Dashboard",
    description: "Dashboard surface visibility and behavior in the customer-facing portals"
  },
  DMS: {
    key: "dms",
    label: "DMS",
    description: "Dealer Management System integration configuration"
  },
  EMAIL_SCRAPING: {
    key: "email-scraping",
    label: "Email Scraping",
    description: "Email scraping and parsing configuration"
  },
  FRAUD_AUDIT: {
    key: "fraud-audit",
    label: "Fraud & Audit",
    description: "Fraud detection and audit trail configuration"
  },
  FUEL: {
    key: "fuel",
    label: "Fuel",
    description: "Fuel pricing and calculation settings"
  },
  GUESTRIDES: {
    key: "guestrides",
    label: "Guest Rides",
    description: "Guest ride feature configuration and access settings"
  },
  HOPDRIVE_CONTACTS: {
    key: "hopdrive-contacts",
    label: "HopDrive Contacts",
    description: "HopDrive contact information and support settings"
  },
  INTEGRATIONS: {
    key: "integrations",
    label: "Integrations",
    description: "External integration configuration and settings"
  },
  MOVE_PLANNING: {
    key: "move-planning",
    label: "Move Planning",
    description: "Move planning, estimation, and move type configuration"
  },
  NOTIFICATIONS: {
    key: "notifications",
    label: "Notifications",
    description: "Email and notification preferences"
  },
  OPERATIONAL_STATE: {
    key: "operational-state",
    label: "Operational State",
    description: "System-managed operational state written by backend processes"
  },
  OUTCOMES: {
    key: "outcomes",
    label: "Outcomes",
    description: "Move outcome configuration, notifications, and visibility settings"
  },
  PRICING: {
    key: "pricing",
    label: "Pricing & Fees",
    description: "Pricing and fee configuration"
  },
  PRIVATE: {
    key: "private",
    label: "Private",
    description: "Private configuration settings"
  },
  PRODUCT_EXPERIENCE: {
    key: "product-experience",
    label: "Product Experience",
    description: "Presentation, navigation, and visibility of products in the customer-facing portals"
  },
  REFERENCE_NUMBER: {
    key: "reference-number",
    label: "Reference Number",
    description: "Reference number settings and requirements"
  },
  REGION_PIPELINE: {
    key: "region-pipeline",
    label: "Region Pipeline",
    description: "Region pipeline configuration and settings"
  },
  REPORTING: {
    key: "reporting",
    label: "Reporting",
    description: "Customer-facing reporting dashboard visibility (tabs and modules)"
  },
  RIDESHARE: {
    key: "rideshare",
    label: "Rideshare",
    description: "Rideshare integration and calling configuration"
  },
  REDCAP: {
    key: "redcap",
    label: "RedCap",
    description: "RedCap integration credentials and program mapping for Ford and Lincoln customers"
  },
  SUPER_DISPATCH: {
    key: "super-dispatch",
    label: "Super Dispatch",
    description: "Super Dispatch integration behavior, order routing, charge sync, and photo sync"
  },
  SERVICE_RADIUS: {
    key: "service-radius",
    label: "Service Radius",
    description: "Service area radius and eligibility configuration"
  },
  SIXT: {
    key: "sixt",
    label: "Sixt",
    description: "Sixt integration \u2014 Slack review channel, nearest-customer match bounds, and the move-creation switch"
  },
  THIRD_PARTY_PAYER: {
    key: "third-party-payer",
    label: "Third Party Payer",
    description: "Third-party payer configuration and default settings"
  },
  MOBILITY: {
    key: "mobility",
    label: "Mobility",
    description: "Mobility product configuration (mobile service, shuttle, parts delivery)"
  },
  PROGRAMS: {
    key: "programs",
    label: "Programs",
    description: "OEM program features a program turns on for its enrolled dealers"
  },
  WORKFLOWS: {
    key: "workflows",
    label: "Workflows",
    description: "Workflow configuration and routing settings"
  },
  GPS_MOVE_STATUS: {
    key: "gps-move-status",
    label: "GPS Move Status",
    description: "Whether GPS may move a move's status: shadow or live mode, the arrival and departure policies, the phone's optimistic arrivals and departures, and the Start Pickup gate"
  },
  GPS_GEOFENCE_EVIDENCE: {
    key: "gps-geofence-evidence",
    label: "GPS Geofence Evidence",
    description: "Fence size and how much ping evidence the server needs before it accepts a GPS arrival or departure. Applies in shadow and live mode alike: in shadow it decides what the server would have done"
  },
  GPS_STALE_MOVES: {
    key: "gps-stale-moves",
    label: "GPS Stale-Move Recovery",
    description: "How long a move may sit at each status before the stale-move cron checks its GPS trail for a missed step"
  },
  ROUTE_MONITORING: {
    key: "route-monitoring",
    label: "Route Monitoring",
    description: "The driver app's off-route alert and unplanned-stop detection, and the post-move route compliance summary. Independent of GPS Move Status mode"
  }
};
var DEFINITION_KINDS = {
  /** User-configurable setting that can be set via UI/API (default) */
  SETTING: "setting",
  /** System-managed operational state written by backend processes */
  OUTPUT: "output"
};
var ROLES = {
  ADMIN: "admin",
  DISPATCHER: "dispatcher",
  DRIVER: "driver",
  CONSUMER: "consumer",
  DEALER_ADMIN: "dealer-admin",
  DEALER: "dealer",
  DEALER_USER: "dealer_user",
  DEALER_MANAGER: "dealer_manager",
  DEALER_ADMIN_ORG: "dealer_admin",
  DEALER_SUPER_ADMIN: "dealer-super-admin",
  PENDING_DRIVER: "pending-driver"
};
function effectiveWritableByRoles(definition7) {
  return definition7.writableByRoles ?? definition7.readableByRoles;
}
function effectiveReadableAtLevels(definition7) {
  return definition7.readableAtLevels ?? ALL_CONFIG_LEVELS;
}
function define(definition7) {
  if (!definition7.readableByRoles.includes(ROLES.ADMIN)) {
    throw new Error(
      `Definition "${definition7.key}" must include ROLES.ADMIN in readableByRoles. Received: [${definition7.readableByRoles.join(", ")}]`
    );
  }
  if (definition7.writableByRoles !== void 0) {
    if (!definition7.writableByRoles.includes(ROLES.ADMIN)) {
      throw new Error(
        `Definition "${definition7.key}" must include ROLES.ADMIN in writableByRoles. Received: [${definition7.writableByRoles.join(", ")}]. To make a definition nobody edits, narrow writableAtLevels instead.`
      );
    }
    const unreadableWriters = definition7.writableByRoles.filter(
      (role) => !definition7.readableByRoles.includes(role)
    );
    if (unreadableWriters.length > 0) {
      throw new Error(
        `Definition "${definition7.key}" grants a write to roles that cannot read it: [${unreadableWriters.join(", ")}]. writableByRoles must be a subset of readableByRoles (contract ADR section 13).`
      );
    }
  }
  if (definition7.readableAtLevels !== void 0) {
    const readableAtLevels = definition7.readableAtLevels;
    const unreadableLevels = definition7.writableAtLevels.filter(
      (level) => !readableAtLevels.includes(level)
    );
    if (unreadableLevels.length > 0) {
      throw new Error(
        `Definition "${definition7.key}" is writable at levels it cannot be read at: [${unreadableLevels.join(", ")}]. writableAtLevels must be a subset of readableAtLevels.`
      );
    }
  }
  return definition7;
}

// src/definitions/dry-run-behavior.ts
var dry_run_behavior_exports = {};
__export(dry_run_behavior_exports, {
  definition: () => definition,
  schema: () => schema
});
import { z } from "zod";
var schema = z.enum(["default-off", "default-on", "forced-off", "forced-on"]);
var definition = define({
  key: "dry_run_behavior",
  schema,
  label: "Dry Run Behavior",
  description: "Choose the behavior around dry run cancellations through move outcome. When a dry run is applied to a move, this will charge the ar cost of a move to the customer for cancellations instead of using the cancellation fee.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.CONTRACT],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: "default-off"
});

// src/definitions/customer-values.ts
var customer_values_exports = {};
__export(customer_values_exports, {
  definition: () => definition2,
  schema: () => schema2
});
import { z as z2 } from "zod";
var schema2 = z2.object({
  program: z2.string().describe('Program name identifier (e.g., "GMA")').optional(),
  dealer_code: z2.string().describe("The dealer's own public dealer code (e.g., OEM-stamped code). For external-system surrogate IDs use the per-integration keys below.").optional(),
  billing_program: z2.string().describe("Billing program identifier for invoicing categorization").optional(),
  gma_market: z2.string().describe('GMA market code (e.g., "GX4", "GC2")').optional(),
  gma_region: z2.string().describe('GMA region code (e.g., "SC", "EA", "WE")').optional(),
  gma_program: z2.string().describe("GMA program name for reporting").optional(),
  gma_dealer_cd: z2.string().describe('GMA dealer code (e.g., "TX712")').optional(),
  gma_retailer_name: z2.string().describe("GMA retailer display name for reports").optional(),
  dealerware_dealership_id: z2.string().describe(`Dealerware's internal dealership identifier for this rooftop (e.g., "4259"). Used by the Dealerware connector to route API requests; set during onboarding.`).optional(),
  spark_dealership_id: z2.string().describe("Spark's internal dealership UUID for this rooftop. Used by sparkserv-integration to map inbound Spark webhooks to a HopDrive customer; set during onboarding.").optional()
}).passthrough().describe(
  "Custom key-value data for reporting and integrations. Keys are auto-formatted: lowercase with spaces to underscores."
);
var definition2 = define({
  key: "customer_values",
  schema: schema2,
  label: "Customer Values",
  description: "Custom key-value data for reporting and integrations. Includes external-system surrogate IDs (e.g., Spark, Dealerware, GMA) plus arbitrary passthrough keys. Keys are auto-formatted: lowercase with spaces to underscores.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.CUSTOM_SETTINGS.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.CONTRACT,
    LEVELS.MOVE
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: {}
});

// src/definitions/arrival-policy-shared.ts
import { z as z3 } from "zod";
var TRANSITION_MODES = [
  "automaticWithManual",
  "automaticOnly",
  "manualOnly",
  "automaticWithDelayedManual"
];
var transitionPolicySchema = z3.discriminatedUnion("mode", [
  z3.object({ mode: z3.literal("automaticWithManual") }).describe("Automatic arrival with the manual control always available (driver app 3 default)."),
  z3.object({
    mode: z3.literal("automaticOnly"),
    acceptsStrandingWhenSensorFails: z3.literal(true).describe("Required acknowledgement: with a dead fence or no permission the driver has no manual control.")
  }).describe("GPS enforcement: the manual control never appears. Driver app 4 only; driver app 3 runs this as automaticWithManual."),
  z3.object({ mode: z3.literal("manualOnly") }).describe("Automation off. Crossings are still detected and logged but never move the workflow."),
  z3.object({
    mode: z3.literal("automaticWithDelayedManual"),
    manualDelayMs: z3.number().int().positive().describe("Milliseconds before the manual control opens. No default; zero is automaticWithManual.")
  }).describe("Automation first, manual as a fallback after the delay. Driver app 4 only; driver app 3 runs this as automaticWithManual.")
]);
var DEFAULT_TRANSITION_POLICY = { mode: "automaticWithManual" };
var TRANSITION_POLICY_DESCRIPTION = 'One of four modes. automaticWithManual (default): GPS advances the move and the driver can always advance it too. automaticOnly: GPS enforcement, no manual control; requires "acceptsStrandingWhenSensorFails": true in the same block. manualOnly: GPS crossings are logged but never move the workflow. automaticWithDelayedManual: manual control opens after "manualDelayMs" (required, positive). A block that fails validation falls through to the level below. Driver app 3 enforces automaticWithManual and manualOnly only; it runs automaticOnly and automaticWithDelayedManual as automaticWithManual and logs move.arrival_policy.degraded.';

// src/definitions/guestrides.ts
var guestrides_exports = {};
__export(guestrides_exports, {
  APPROVAL_CHANNELS: () => APPROVAL_CHANNELS,
  APPROVAL_REQUIRES_APPROVER_MESSAGE: () => APPROVAL_REQUIRES_APPROVER_MESSAGE,
  GUESTRIDES_MAX_TRIP_MILES_CEILING: () => GUESTRIDES_MAX_TRIP_MILES_CEILING,
  definition: () => definition3,
  objectSchema: () => objectSchema,
  schema: () => schema3
});
import { z as z4 } from "zod";
var GUESTRIDES_MAX_TRIP_MILES_CEILING = 200;
var APPROVAL_CHANNELS = ["sms", "email"];
var APPROVAL_REQUIRES_APPROVER_MESSAGE = "Name an approver before requiring manager approval.";
var objectSchema = z4.object({
  guest_portal_enabled: z4.boolean().describe("Enable or disable the ability for guests to call their own ride.").optional(),
  max_trip_miles: z4.number().nonnegative().max(GUESTRIDES_MAX_TRIP_MILES_CEILING).describe(`Maximum trip distance in miles allowed for a guest ride, at most ${GUESTRIDES_MAX_TRIP_MILES_CEILING}.`).optional(),
  require_approval: z4.boolean().describe(
    "Require a named manager to approve each guest ride before it is booked with a rideshare provider. Absent or false books as soon as the ride is called. Turning it on requires approver_user_id."
  ).optional(),
  approver_user_id: z4.number().int().positive().nullable().describe(
    "The HopDrive user id of the manager who approves guest rides for this rooftop. Stored as an id so contact changes follow the user record. One approver per rooftop."
  ).optional(),
  approval_notification_channels: z4.array(z4.enum(APPROVAL_CHANNELS)).nonempty().refine((channels) => new Set(channels).size === channels.length, {
    message: "List each notification channel at most once."
  }).describe(
    'How the approver is told a ride is waiting: ["sms"], ["email"], or both. An empty list is refused, because an approval nobody hears about strands the ride.'
  ).optional()
}).strict();
var schema3 = objectSchema.superRefine((value, ctx) => {
  if (value.require_approval === true && (value.approver_user_id === void 0 || value.approver_user_id === null)) {
    ctx.addIssue({
      code: z4.ZodIssueCode.custom,
      path: ["approver_user_id"],
      message: APPROVAL_REQUIRES_APPROVER_MESSAGE
    });
  }
}).describe(
  "Guest ride settings for your rooftop: whether guests can call their own ride, how far a guest ride may go, and whether a manager approves each ride before it is booked."
);
var definition3 = define({
  key: "guestrides",
  schema: schema3,
  label: "Guest Rides",
  description: "Guest ride settings for your rooftop: whether guests can call their own ride, how far a guest ride may go, and whether a manager approves each ride before it is booked.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.GUESTRIDES.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  // Card #1184 made this dealer-visible so the dealer portal's Guest Rides page has a Settings
  // tab. Card #1411 kept that, and made the tab safe by removing the fields that made the
  // whole-key write dangerous. The blast radius of this write is the operational and approval
  // fields above, which is the state #1323's comment said could only be reached by a split.
  // The plain dealer reads, so their Settings tab shows the values greyed out instead of empty.
  readableByRoles: [ROLES.ADMIN, ROLES.DEALER_ADMIN, ROLES.DEALER_SUPER_ADMIN, ROLES.DEALER],
  // Explicit, never omitted: an absent write list falls back to the read list, which would
  // quietly make the plain dealer a writer.
  writableByRoles: [ROLES.ADMIN, ROLES.DEALER_ADMIN, ROLES.DEALER_SUPER_ADMIN],
  defaultValue: {
    guest_portal_enabled: false,
    max_trip_miles: 50,
    // Approval off is how every rooftop behaved before the setting existed, so nothing changes
    // on deploy. Both channels are the default so a rooftop that turns approval on reaches its
    // approver without discovering a second setting.
    require_approval: false,
    approval_notification_channels: ["sms", "email"]
  }
});

// src/definitions/scheduler.ts
var scheduler_exports = {};
__export(scheduler_exports, {
  KNOWN_SCHEDULERS: () => KNOWN_SCHEDULERS,
  KNOWN_SCHEDULER_VALUES: () => KNOWN_SCHEDULER_VALUES,
  definition: () => definition4,
  isKnownScheduler: () => isKnownScheduler,
  schema: () => schema4
});
import { z as z5 } from "zod";
var KNOWN_SCHEDULERS = {
  XTIME: "xtime",
  MYKAARMA: "mykaarma",
  CDK: "cdk",
  DEALER_FX: "dealer-fx",
  UPDATE_PROMISE: "update-promise",
  TRAXTION: "traxtion",
  REYNOLDS: "reynolds",
  TEKION: "tekion",
  DEALERSOCKET: "dealersocket",
  AUTOLOOP: "autoloop",
  AFFINITIV: "affinitiv",
  DEALERTRACK: "dealertrack",
  PBS: "pbs",
  DOMINION: "dominion",
  DEALERBUILT: "dealerbuilt",
  AUTO_MATE: "auto-mate",
  QUORUM: "quorum",
  ADVENT: "advent",
  SERVICE_PRO: "service-pro",
  ONE_COMMAND: "one-command"
};
var KNOWN_SCHEDULER_VALUES = Object.values(KNOWN_SCHEDULERS);
function isKnownScheduler(value) {
  return KNOWN_SCHEDULER_VALUES.includes(value);
}
var schema4 = z5.object({
  type: z5.string().describe(
    'The scheduling system the dealer uses, e.g. "xtime". Should match a value from KNOWN_SCHEDULERS where possible; arbitrary strings are accepted for vendors not yet in the seeded list.'
  ).optional()
}).strict().describe(
  "Metadata about the dealer's appointment scheduling system. Relay-agnostic; auto-populated today from inbound Spark webhooks."
);
var definition4 = define({
  key: "scheduler",
  schema: schema4,
  label: "Scheduler",
  description: `The dealer's appointment scheduling system (e.g. "xtime"). Auto-populated from inbound integration webhooks; the canonical place for Client Success to confirm which scheduling system a rooftop is on.`,
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.INTEGRATIONS.key,
  writableAtLevels: [LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  // Readable by HopDrive admins plus dealer admins at the customer
  // (DEALER_ADMIN) and organization (DEALER_SUPER_ADMIN) levels, matching
  // the org + customer scope this setting is written at.
  readableByRoles: [ROLES.ADMIN, ROLES.DEALER_ADMIN, ROLES.DEALER_SUPER_ADMIN],
  defaultValue: {
    type: ""
  }
});

// src/definitions/superdispatch-settings.ts
var superdispatch_settings_exports = {};
__export(superdispatch_settings_exports, {
  SUPERDISPATCH_SUBSCRIPTION: () => SUPERDISPATCH_SUBSCRIPTION,
  definition: () => definition5,
  schema: () => schema5
});
import { z as z6 } from "zod";
var schema5 = z6.object({
  syncVehiclePhotos: z6.boolean().describe(
    "Sends HopDrive inspection photos to the matching Super Dispatch vehicle. Only the photo steps Super Dispatch has a slot for are sent (the four corner shots on the standard workflows). **This delays the pickup and delivery notification the shipper receives**, because Super Dispatch closes each inspection the moment the status changes, so the photos must be sent first \u2014 normally seconds, up to ten minutes on a bad connection. Worth the customer knowing before it is switched on."
  ).optional(),
  syncDamagePhotos: z6.boolean().describe(
    "Sends damage-report photos to the Super Dispatch vehicle with a damage record attached to each. Independent of inspection photos \u2014 either can be on without the other. Damage photos are sent on a best-effort basis: any still uploading when the status change goes through are skipped, because Super Dispatch will not accept them afterwards."
  ).optional(),
  arBehavior: z6.enum(["default", "override_hopdrive_price", "correct_transport_cost"]).describe(
    `How HopDrive's price and the shipper's order price are reconciled. The two corrections are mutually exclusive \u2014 replacing our price with theirs and then adjusting their total to match ours would be circular \u2014 so this is one choice, not two switches.

- **Default** \u2014 neither is touched. HopDrive bills its own price; their order keeps whatever they entered, and any difference stays a difference.
- **Use their price** \u2014 at ingest, HopDrive's AR price is replaced by the price on the Super Dispatch order, so billing follows what the shipper entered rather than HopDrive lane pricing.
- **Correct their total** \u2014 HopDrive bills its own price and posts a signed adjustment line on their order (labelled *price adjusted for lane pricing*) so the shipper's total matches. Their original entry stays intact and the difference is visible rather than silent. **This changes what the customer is billed on their own record \u2014 get their agreement first.**`
  ).optional(),
  cancelBehavior: z6.enum(["notify_only", "auto_cancel"]).describe(
    `What happens on the shipper's order when HopDrive cancels a move. One choice, because cancelling their order and asking a human to decide are alternatives, not additions.

- **Post to Slack, leave the order alone** (default) \u2014 the order is untouched and a Slack message goes to this customer's channel so the team can decide whether to cancel it or reschedule. A cancellation is not always the end of the job, and HopDrive cannot tell the difference from the move alone.
- **Cancel it in Super Dispatch** \u2014 the order is cancelled automatically, with HopDrive's cancel reason mapped onto Super Dispatch's own reason types. **This closes the job on the customer's own record with no human in the loop** \u2014 if they habitually reschedule rather than cancel, this will cancel orders they expected to keep. A failure to cancel still raises a Slack alert, so a missed cancellation is never silent.`
  ).optional(),
  invoiceEmail: z6.string().describe(
    "Where Super Dispatch sends its copy of the invoice. **Required as soon as any charge above is synced**, because submitting the invoice is what makes those charges visible and an invoice has to be addressed somewhere. With no address configured nothing is submitted, the charges stay invisible to the shipper, and a Slack alert is raised rather than guessing at a recipient. Super Dispatch does not validate this against the shipper, so it is ours to choose: a HopDrive billing alias is the usual answer."
  ).optional(),
  allowedAccessorialCodes: z6.array(z6.string()).describe(
    "Which HopDrive accessorial codes are posted to the Super Dispatch order as expenses once the move settles \u2014 e.g. `fuel`, `tow`, `toll`, `delay`. Codes with a native Super Dispatch expense type use it (`tow` becomes *pulling fee*); anything else posts as *other*, labelled with the code. Empty means no expenses are sent at all.\n\n**Enabling any of these also submits the Super Dispatch invoice for each load**, because an expense on an order is not shown to the shipper until the load is invoiced \u2014 so syncing charges without invoicing would reach nobody. Every settled load is invoiced, including loads that carry no accessorials, so their board does not end up half invoiced. Set the invoice email below."
  ).optional(),
  slackChannel: z6.string().describe(
    "Slack channel for this customer's Super Dispatch failure alerts, without the leading `#`. **The alert bot must be invited to the channel or the messages will never post.** Leave blank to use the integration's default channel."
  ).optional()
}).strict().describe("What HopDrive sends back to Super Dispatch for this organization or customer.").superRefine((settings, ctx) => {
  const postsToOrder = (settings.allowedAccessorialCodes?.length ?? 0) > 0 || settings.arBehavior === "correct_transport_cost";
  if (postsToOrder && !settings.invoiceEmail?.trim()) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["invoiceEmail"],
      message: "An invoice email is required when charges are synced to the order: Super Dispatch does not show a charge to the shipper until the load is invoiced, and an invoice has to be addressed somewhere."
    });
  }
});
var SUPERDISPATCH_SUBSCRIPTION = {
  events: [
    "move_pickup_successful",
    "move_delivery_successful",
    "move_charges_settled",
    "move_cancel_succeeded",
    "move_cancel_partial"
  ],
  /** Per environment: the integration site's pretty path, pinned by its `config.path`. */
  targetUrl: {
    test: "https://super-dispatch-test.hopdrive.io/v1/handleHopDriveWebhook",
    prod: "https://super-dispatch.hopdrive.io/v1/handleHopDriveWebhook"
  },
  /** Written on rows this integration creates, so a human can tell where one came from. */
  description: "Super Dispatch integration",
  version: "1.0.0"
};
var definition5 = define({
  key: "superdispatch_settings",
  schema: schema5,
  label: "Super Dispatch Sync",
  description: "What HopDrive sends back to Super Dispatch once a move is under way: which accessorial charges reach the shipper's order, whether their transport cost is corrected, what happens to their order when a move is cancelled, and whether inspection and damage photos are sent. Set on the organization; override on a customer only where that rooftop genuinely differs.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.SUPER_DISPATCH.key,
  warning: "Several of these write to the customer's own Super Dispatch record \u2014 their billed total, whether their order gets cancelled, when their pickup and delivery notifications arrive, and whether their loads get invoiced. Confirm with the customer before enabling charge sync, transport-cost correction, automatic cancellation or photo sync.",
  writableAtLevels: [LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  // Nothing is sent until someone opts in, so an unconfigured org sends nothing.
  defaultValue: { allowedAccessorialCodes: [], arBehavior: "default", cancelBehavior: "notify_only" }
});

// src/definitions/carsarrive-settings.ts
var carsarrive_settings_exports = {};
__export(carsarrive_settings_exports, {
  CARSARRIVE_DEFAULT_INVOICE_MAPPING: () => CARSARRIVE_DEFAULT_INVOICE_MAPPING,
  CARSARRIVE_INVOICE_BUCKETS: () => CARSARRIVE_INVOICE_BUCKETS,
  CARSARRIVE_SUBSCRIPTION: () => CARSARRIVE_SUBSCRIPTION,
  definition: () => definition6,
  schema: () => schema6
});
import { z as z7 } from "zod";
var CARSARRIVE_INVOICE_BUCKETS = ["standardTransport", "tolls", "fuel", "other"];
var CARSARRIVE_DEFAULT_INVOICE_MAPPING = {
  standardTransport: ["transport"],
  tolls: ["toll"],
  fuel: ["fuel"],
  other: ["delay", "surge", "tow", "roadside"]
};
var invoiceMappingSchema = z7.object({
  standardTransport: z7.array(z7.string()).optional(),
  tolls: z7.array(z7.string()).optional(),
  fuel: z7.array(z7.string()).optional(),
  other: z7.array(z7.string()).optional()
}).strict();
var schema6 = z7.object({
  syncVehiclePhotos: z7.boolean().describe(
    "Waits for the move's inspection photos before reporting pickup and delivery to CarsArrive, so the photos actually make it onto the load. **This delays the pickup and delivery notification CarsArrive receives** \u2014 normally seconds, up to ten minutes on a bad connection. With this off the callback goes out immediately and carries only whatever photos happened to have finished uploading, which on a fast move is usually none."
  ).optional(),
  cancelBehavior: z7.enum(["auto_cancel", "notify_only"]).describe(
    `What happens to the CarsArrive load when HopDrive cancels a move. One choice, because cancelling their load and asking a human to decide are alternatives, not additions.

- **Cancel it in CarsArrive** (default, and the long-standing behaviour) \u2014 the load is rejected back to CarsArrive automatically. Unlike Super Dispatch this causes no echo loop, because CarsArrive does not webhook the cancellation back to us.
- **Post to Slack, leave the load alone** \u2014 the load is untouched and a Slack message goes to this customer's channel so the team can decide whether to cancel it or reschedule. **CarsArrive will keep believing the vehicle is being moved until somebody acts.**`
  ).optional(),
  invoiceMapping: invoiceMappingSchema.describe(
    "Which HopDrive accessorial names land in each of CarsArrive's four invoice buckets when a move is delivered. Matched case-insensitively against the accounts-receivable line names. Anything not listed in any bucket is **not invoiced to CarsArrive at all** \u2014 HopDrive still bills it, but their invoice will not show it, so a charge left unmapped is a silent revenue gap rather than an error."
  ).optional(),
  slackChannel: z7.string().describe(
    "Slack channel for this customer's CarsArrive failure alerts, without the leading `#`. **The alert bot must be invited to the channel or the messages will never post.** Leave blank to use the integration's default channel."
  ).optional()
}).strict().describe("What HopDrive sends back to CarsArrive for this organization or customer.");
var CARSARRIVE_SUBSCRIPTION = {
  events: [
    "move_dispatched",
    "move_pickup_started",
    "move_pickup_successful",
    "move_delivery_successful",
    "move_cancel_succeeded",
    "move_cancel_partial"
  ],
  /** Per environment: the integration site's pretty path, pinned by its `config.path`. */
  targetUrl: {
    test: "https://carsarrive-test.hopdrive.io/v1/handleHopDriveWebhook",
    prod: "https://carsarrive.hopdrive.io/v1/handleHopDriveWebhook"
  },
  /** Written on rows this integration creates, so a human can tell where one came from. */
  description: "CarsArrive integration",
  version: "1.0.0"
};
var definition6 = define({
  key: "carsarrive_settings",
  schema: schema6,
  label: "CarsArrive Sync",
  description: "What HopDrive sends back to CarsArrive once a move is under way: whether inspection photos are waited for and sent, what happens to their load when a move is cancelled, and which of HopDrive's charges land in each bucket of their invoice. Set on the organization; override on a customer only where that rooftop genuinely differs.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.CARS_ARRIVE.key,
  warning: "Two of these are customer-visible on CarsArrive's own record: when their pickup and delivery notifications arrive, and what their invoice adds up to. Confirm with the customer before turning photo sync on or changing the invoice mapping.",
  writableAtLevels: [LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  /**
   * Photo sync off (it delays their notifications, so it needs an explicit
   * yes), cancel and invoice behaviour set to exactly what the integration did
   * before this key existed — shipping the setting must not change anyone's
   * behaviour on its own.
   */
  defaultValue: {
    cancelBehavior: "auto_cancel",
    invoiceMapping: {
      standardTransport: [...CARSARRIVE_DEFAULT_INVOICE_MAPPING.standardTransport],
      tolls: [...CARSARRIVE_DEFAULT_INVOICE_MAPPING.tolls],
      fuel: [...CARSARRIVE_DEFAULT_INVOICE_MAPPING.fuel],
      other: [...CARSARRIVE_DEFAULT_INVOICE_MAPPING.other]
    }
  }
});

export {
  __export,
  CONFIG_LEVELS_REGISTRY,
  LEVELS,
  ALL_CONFIG_LEVELS,
  CONFIG_TABLES,
  getConfigLevelInfo,
  getConfigTableForLevel,
  levelHasTable,
  CATEGORIES,
  DEFINITION_KINDS,
  ROLES,
  effectiveWritableByRoles,
  effectiveReadableAtLevels,
  define,
  definition,
  dry_run_behavior_exports,
  schema2 as schema,
  definition2,
  customer_values_exports,
  TRANSITION_MODES,
  transitionPolicySchema,
  DEFAULT_TRANSITION_POLICY,
  TRANSITION_POLICY_DESCRIPTION,
  APPROVAL_CHANNELS,
  APPROVAL_REQUIRES_APPROVER_MESSAGE,
  definition3,
  guestrides_exports,
  KNOWN_SCHEDULERS,
  KNOWN_SCHEDULER_VALUES,
  isKnownScheduler,
  definition4,
  scheduler_exports,
  SUPERDISPATCH_SUBSCRIPTION,
  definition5,
  superdispatch_settings_exports,
  CARSARRIVE_INVOICE_BUCKETS,
  CARSARRIVE_DEFAULT_INVOICE_MAPPING,
  CARSARRIVE_SUBSCRIPTION,
  definition6,
  carsarrive_settings_exports
};
//# sourceMappingURL=chunk-B45MFSSL.mjs.map